import React, { useEffect } from "react";

import { Grid, makeStyles, Typography } from "@material-ui/core/";
import { useSelector } from "react-redux";
import Aux from "../../../hoc/Auxilliary";
import focus from "../../../assests/focus.png";
import localizedStrings from "../../../utils/localize";

const useStyle = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    padding: "2rem 0",
  },
  heading: {
    color: "#005598",
    fontSize: "1.5rem",
    fontWeight: 400,
  },
  focusContainer: {
    display: "flex",
    width: "100%",
    // justifyContent: "space-between",
  },
  focusItemHeading: {
    color: "#000000",
    fontWeight: 700,
    fontSize: "1.1rem",
    marginBottom: "0.6rem",
    [theme.breakpoints.down("xs")]: {
      marginTop: "1rem",
    },
  },
  itemMain: {
    display: "flex",
    flexDirection: "column",
    // justifyContent: "space-between",
    paddingBottom: "1rem",
    [theme.breakpoints.down("xs")]: {
      height: "auto",
    },
  },
  focusImage: {
    display: "flex",
    alignItems: "center",
    height: "100%",
    justifyContent: "center",
    width: "100%",
  },
  marginGap: {
    marginTop: "5%",
    [theme.breakpoints.down("xs")]: {
      marginTop: "auto",
    },
  },
}));

const Focus = (props) => {
  const classes = useStyle(props);
  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  return (
    <Aux>
      <Grid container item className={classes.root}>
        <Typography component="h1" className={classes.heading}>
          {localizedStrings.homePage.focus.heading}
        </Typography>
      </Grid>
      <Grid container item xs={11} sm={12} className={classes.focusContainer}>
        <Grid container item xs={11} sm={4} style={{ margin: "0 auto" }}>
          <Grid container item className={classes.itemMain}>
            <Typography component="div">
              <Typography component="h2" className={classes.focusItemHeading}>
                {localizedStrings.homePage.focus.collegiality}
              </Typography>
              <Typography>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
                Felis donec et odio pellentesque diam volutpat. Nulla aliquet
                enim tortor at.
              </Typography>
            </Typography>
            <Typography component="div" className={classes.marginGap}>
              <Typography component="h2" className={classes.focusItemHeading}>
                {localizedStrings.homePage.focus.innovation}
              </Typography>
              <Typography>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </Typography>
            </Typography>
          </Grid>
        </Grid>
        <Grid container item xs={11} sm={4} style={{ margin: "0 auto" }}>
          <div className={classes.focusImage}>
            <img src={focus} width="60%" alt="Focus" />
          </div>
        </Grid>

        <Grid container item xs={11} sm={4} style={{ margin: "0 auto" }}>
          <Grid container item className={classes.itemMain}>
            <Typography component="div">
              <Typography component="h2" className={classes.focusItemHeading}>
                {localizedStrings.homePage.focus.inclusivity}
              </Typography>
              <Typography>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ac
                felis donec et odio pellentesque. Proin libero nunc consequat
                interdum varius sit.
              </Typography>
            </Typography>
            <Typography component="div" className={classes.marginGap}>
              <Typography component="h2" className={classes.focusItemHeading}>
                {localizedStrings.homePage.focus.excellence}
              </Typography>
              <Typography>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
                Facilisis magna etiam tempor orci eu lobortis elementum.
              </Typography>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Aux>
  );
};

export default Focus;
